export function Footer() {
    return (
        <footer>
            <p>
                Made by Vendicated -{" "}
                <a className="hover-color" href="https://github.com/Vendicated/AovEmbedCreator">
                    Source Code
                </a>
            </p>
        </footer>
    );
}
